import { render, staticRenderFns } from "./Imports.vue?vue&type=template&id=fa5bef72&scoped=true"
import script from "./Imports.vue?vue&type=script&lang=ts"
export * from "./Imports.vue?vue&type=script&lang=ts"
import style0 from "./Imports.vue?vue&type=style&index=0&id=fa5bef72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5bef72",
  null
  
)

export default component.exports